module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/history/history.component.css
// module id = ./src/app/history/history.component.css
// module chunks = main